import { useCallback } from 'react'
import { get } from 'aws-amplify/api'
import { useAppContext, actionTypes } from '../context/AppContext'

export function useRepositories() {
  const { state, dispatch } = useAppContext()
  
  const fetchRepositories = useCallback(async () => {
    dispatch({ type: actionTypes.FETCH_REPOSITORIES_START })
    
    try {
      const { response } = get({
        apiName: 'FetchRepos',
        path: 'repositories'
      })
      const res = await response
      const data = await res.body.json()
      dispatch({
        type: actionTypes.FETCH_REPOSITORIES_SUCCESS,
        payload: data
      })
    } catch (error) {
      console.error(error)
      dispatch({ type: actionTypes.FETCH_REPOSITORIES_ERROR })
    }
  }, [dispatch])
  
  return {
    repositories: state.repositories,
    repoSuggestions: state.repoSuggestions,
    fetchRepositoriesInProgress: state.fetchRepositoriesInProgress,
    fetchRepositoriesHasErrored: state.fetchRepositoriesHasErrored,
    fetchRepositories
  }
}
